import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import Container from "../../components/Container";
import WorkHeader from "../../components/work-contents/WorkHeader";
import WorkContentInterruptCreateTable from "../../components/work-contents/WorkContentInterruptCreateTable";
import Dialog from "../../components/Dialog";
import OverlayLoading from "../../components/OverlayLoading";
import CancelButton from "../../components/forms/buttons/CancelButton";
import GreenButton from "../../components/forms/buttons/GreenButton";
import { workContentService } from "../../services/WorkContentService";
import { strings } from "../../Strings";
import { useSnackbarContext } from "../../components/snackbar/SnackbarContext";

/**
 * 新規作業内容登録ページ（割込み作業）
 * @class WorkContentsInterruptCreatePage
 */
export default function WorkContentsInterruptCreatePage() {
  const [workContents, setWorkContents] = useState({});
  const [isLoading, setLoading] = useState(true);
  const [errors, setErrors] = useState({});
  const [isDialogOpen, setDialogOpen] = useState(false);
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbarContext();

  const { returnWorkId, workType, stoplossId } = useParams();
  const workTypeOption = strings.WORK_TYPE_OPTIONS.find(
    (o) => o.name === workType,
  );

  /**
   * 対象の作業内容詳細を取得する
   * @memberof WorkContentsInterruptCreatePage
   */
  useEffect(() => {
    const getWorkContent = async () => {
      try {
        const result = (await workContentService.get(returnWorkId)).data;
        if (result.success) {
          setWorkContents({
            ...result.body,
            stoplossWorkId: Number(stoplossId),
          });
        }
        setLoading(false);
      } catch (error) {
        console.error(error);
        setLoading(false);
      }
    };
    getWorkContent();
  }, [returnWorkId, stoplossId]);
  /**
   * 変更された入力欄の値を作業内容に反映する
   * @param {string} name 項目名
   * @param {string} value 値
   * @memberof WorkContentsInterruptCreatePage
   */
  const onChange = (name, value) => {
    setWorkContents({ ...workContents, [name]: value });
  };
  /**
   * 入力データをチェックする
   * @memberof WorkContentsInterruptCreatePage
   */
  const checkParams = () => {
    const errors = workContentService.checkInterruptRequired(
      workContents,
      workType,
    );
    setErrors(errors);
    setDialogOpen(Object.keys(errors).length === 0);
  };
  const onStart = async () => {
    try {
      setDialogOpen(false);
      const result = (await workContentService.createDirect(workContents)).data;
      if (result.success) {
        navigate(`/work-contents/edit/${result.body?.workId ?? 1}`, {
          replace: true,
        });
      } else {
        showSnackbar("error", result.message);
      }
    } catch (error) {
      console.error(error);
    }
  };
  return (
    <Container title={`${workTypeOption?.label}を追加`}>
      <div id="work-contents-create-page">
        <WorkHeader
          title={`${workTypeOption?.label}を追加`}
          subTitle="MANUAL INPUT"
        />
        <WorkContentInterruptCreateTable
          title={`${workTypeOption?.label}の手動入力`}
          subtitle="各項目を選択・入力して、作業を開始します"
          workType={workType}
          workContents={workContents}
          onChange={onChange}
          onReset={() => setWorkContents({})}
          onStart={checkParams}
          errors={errors}
        />
      </div>
      <Dialog
        open={isDialogOpen}
        onClose={() => setDialogOpen(false)}
        title="確認"
        actions={
          <>
            <CancelButton onClick={() => setDialogOpen(false)} />
            <GreenButton title="開始する" onClick={onStart} />
          </>
        }
      >
        {`入力内容で${workTypeOption?.label}を開始します。よろしいですか？`}
      </Dialog>
      <OverlayLoading open={isLoading} />
    </Container>
  );
}
